"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVBleHelper = exports.SIGNATURE_RES_PAYLOAD_KO = exports.SIGNATURE_RES_PAYLOAD_OK = exports.UNLOCK_ACK = exports.CHALLENGE_RES_ALREADY_UNLOCKED = exports.CHALLENGE_REQ_PAYLOAD = void 0;
var HEADER_LEN = 4;
var CH_LEN = 2;
var SEQ_LEN = 1;
var NUM_LEN = 1;
var DATA_LEN = 8;
var PACKET_LEN = HEADER_LEN + CH_LEN + SEQ_LEN + NUM_LEN + DATA_LEN;
/* Mobile phone bradcasting the challange request */
exports.CHALLENGE_REQ_PAYLOAD = [16, 17, 18, 19, 20, 21, 22, 23];
/* If epod is already unlocked, it will reply this sequence */
exports.CHALLENGE_RES_ALREADY_UNLOCKED = [17, 16, 15, 14, 13, 12, 11, 10];
exports.UNLOCK_ACK = [24, 25, 26, 27, 28, 29, 30, 31];
exports.SIGNATURE_RES_PAYLOAD_OK = [32, 33, 34, 35, 36, 37, 38, 39];
exports.SIGNATURE_RES_PAYLOAD_KO = [48, 49, 50, 51, 52, 53, 54, 55];
var HEADER = [116, 104, 105, 110]; // "thin
var hex8 = function (value) {
    return value.toString(16).padStart(2, '0');
};
var hex16 = function (value) {
    return value.toString(16).padStart(4, '0');
};
var hexToNumber = function (value) { return parseInt(value, 16); };
var AVBleHelper = /** @class */ (function () {
    function AVBleHelper(raw) {
        if (raw === void 0) { raw = null; }
        this.raw = new Uint8Array(PACKET_LEN).fill(0);
        if (null != raw) {
            this.raw = raw;
        }
        return this;
    }
    AVBleHelper.uuidToBytes = function (uuid) {
        var str = uuid.replace(/\-/g, "");
        var chunks = [];
        for (var i = 0, charsLength = str.length; i < charsLength; i += 2) {
            chunks.push(str.substring(i, i + 2));
        }
        return chunks.map(function (hex) { return hexToNumber(hex); });
    };
    AVBleHelper.prototype.fromValues = function (channel, seq, num, data) {
        var newRaw = HEADER.concat([
            channel >> 8,
            channel & 0xff,
            seq,
            num,
        ]).concat(data);
        this.raw = Uint8Array.from(newRaw);
        return this;
    };
    AVBleHelper.prototype.getRaw = function () {
        return this.raw;
    };
    AVBleHelper.prototype.getHeader = function () {
        return this.raw.slice(0, HEADER_LEN);
    };
    AVBleHelper.prototype.getChannel = function () {
        //console.log('[BLE][getChannel] ' + this.raw.slice(HEADER_LEN, HEADER_LEN + CH_LEN)[0] + "   " + this.raw.slice(HEADER_LEN, HEADER_LEN + CH_LEN)[1]);
        return ((this.raw.slice(HEADER_LEN, HEADER_LEN + CH_LEN)[0] << 8) |
            this.raw.slice(HEADER_LEN, HEADER_LEN + CH_LEN)[1]);
    };
    AVBleHelper.prototype.getSeq = function () {
        return this.raw.slice(HEADER_LEN + CH_LEN, HEADER_LEN + CH_LEN + SEQ_LEN)[0];
    };
    AVBleHelper.prototype.getNum = function () {
        return this.raw.slice(HEADER_LEN + CH_LEN + SEQ_LEN, HEADER_LEN + CH_LEN + SEQ_LEN + NUM_LEN)[0];
    };
    AVBleHelper.prototype.getData = function () {
        return this.raw.slice(HEADER_LEN + CH_LEN + SEQ_LEN + NUM_LEN);
    };
    AVBleHelper.prototype.isValid = function () {
        var match = true;
        if (this.raw.length != PACKET_LEN)
            return false;
        for (var i = 0; i < HEADER.length; i++) {
            if (this.raw[i] != HEADER[i]) {
                match = false;
                break;
            }
        }
        return match;
    };
    AVBleHelper.prototype.convertData = function (message) {
        var units = [];
        var _chunks = [];
        for (var i = 0; i < message.length; i += 2) {
            units.push(parseInt(message.slice(i, i + 2), 16));
        }
        //console.log('[convertData] units', units);
        for (var i = 0; i < units.length; i += DATA_LEN) {
            var end = i + DATA_LEN < units.length ? i + DATA_LEN : units.length;
            var d = units.slice(i, end);
            console.log('[convertData] d.length', d.length);
            if (d.length < DATA_LEN) {
                for (var k = 0; k < DATA_LEN - d.length; k++) {
                    d.push(0);
                }
            }
            _chunks.push(d);
        }
        //console.log('[convertData] _chunks', _chunks);
        return _chunks;
    };
    AVBleHelper.prototype.toUUID = function () {
        return ("".concat(hex8(this.getRaw()[0])).concat(hex8(this.getRaw()[1])).concat(hex8(this.getRaw()[2])).concat(hex8(this.getRaw()[3])) +
            "-".concat(hex16(this.getChannel())) +
            "-".concat(hex8(this.getSeq())).concat(hex8(this.getNum())) +
            "-" +
            this.getData()
                .reverse()
                .slice(0, 2)
                .reduce(function (prev, element) { return prev + hex8(element); }, '') +
            "-" +
            this.getData()
                .reverse()
                .slice(2)
                .reduce(function (prev, element) { return prev + hex8(element); }, ''));
    };
    return AVBleHelper;
}());
exports.AVBleHelper = AVBleHelper;
